var BACKSPACE_KEYCODE = 8;
var DELETE_KEYCODE = 46;
export default function isLinkRemovalRelatedEvent(evt, editor) {
    if (evt.eventType === 6 /* ContentChanged */) {
        return true;
    }
    if (evt.eventType === 0 /* KeyDown */) {
        var domEvent = evt;
        var keyboardEvent = domEvent.rawEvent;
        return keyboardEvent.which === BACKSPACE_KEYCODE || keyboardEvent.which === DELETE_KEYCODE;
    }
    if (evt.eventType === 1 /* KeyPress */) {
        return !editor.getSelectionRange().collapsed;
    }
    return false;
}
//# sourceMappingURL=isLinkRemovalRelatedEvent.js.map